import { render } from "./LeadCanceled.vue?vue&type=template&id=8f0b1b0c"
import script from "./LeadCanceled.vue?vue&type=script&lang=js"
export * from "./LeadCanceled.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/preflight.unbundledlegalhelp.dev.farm/releases/000000/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__